import { Instance, types } from 'mobx-state-tree';

import AlertModel, { AlertTypes, IAlertModel } from './models/AlertModel';

const AlertStore = types
    .model('AlertStore', {
        list: types.map(AlertModel),
    })
    .actions(self => {
        const warning = (title: string, description: string) => {
            const id = self.list.size.toString();
            self.list.set(id, {
                id,
                type: AlertTypes.warning,
                title,
                description,
            });
        };
        const success = (title: string, description: string) => {
            const id = self.list.size.toString();
            self.list.set(self.list.size.toString(), {
                id,
                type: AlertTypes.success,
                title,
                description,
            });
        };
        const error = (title: string, description: string) => {
            const id = self.list.size.toString();
            self.list.set(self.list.size.toString(), {
                id,
                type: AlertTypes.error,
                title,
                description,
            });
        };
        const info = (title: string, description: string) => {
            const id = self.list.size.toString();
            self.list.set(self.list.size.toString(), {
                id,
                type: AlertTypes.info,
                title,
                description,
            });
        };

        const remove = (alert: IAlertModel) => {
            self.list.delete(alert.id);
        };

        return { warning, success, error, info, remove };
    });

export interface IAlertStore extends Instance<typeof AlertStore> {}

export default AlertStore;
